<template>
  <div class="eraser-menu-component">
    <div
      v-for="item in menuItems"
      class="menu-item"
      :key="item.key"
      :class="{
        active: item.key === currentKey,
      }"
      @click="handleClick(item.key)"
    >
      <el-tooltip
        popper-class="live-room-tooltip"
        effect="dark"
        :content="item.label"
        placement="top"
        :disabled="!item.showTooltip || isHXApp"
      >
        <img
          :src="require('../../assets/images/' + item.imgName + '.png')"
          alt=""
        />
      </el-tooltip>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "EraserMenu",
  data() {
    return {
      menuItems: [
        {
          key: "eraser",
          label: "橡皮擦",
          imgName: "eraser-icon",
          showTooltip: false,
        },
        { key: "clear", label: "清屏", imgName: "clear", showTooltip: true },
      ],
      currentKey: "eraser",
    };
  },
  methods: {
    handleClick(key) {
      if (key === "clear") {
        this.currentKey = "clear";
        if (this.whiteBoardService.isEmpty()) {
          this.whiteBoardService.clear();
          this.$emit("hide-menu");
          return;
        } else {
          this.$confirm("是否确定清除白板内容", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            closeOnClickModal: false,
            center: true,
            customClass: "saas-live-confirm-message",
            confirmButtonClass: "confirm-btn",
            cancelButtonClass: "cancel-btn",
          })
            .then(() => {
              this.whiteBoardService.clear();
            })
            .catch(() => {});
        }
      }
    },
    handleStyleChange() {
      this.whiteBoardService.setEraserTool();
      this.currentKey = "eraser";
    },
  },
  computed: {
    ...mapState("live", ["whiteBoardService", "isHXApp"]),
  },
};
</script>

<style lang="scss" scoped>
.eraser-menu-component {
  padding: 8px;
  background: #ffffff;
  box-shadow: 0px 4px 10px 0px rgba(20, 20, 43, 0.04);
  border-radius: 10px;
  border: 1px solid $live-room-border-color;
  display: flex;
  align-items: center;
  justify-content: center;
  .menu-item {
    padding: 4px;
    width: 20px;
    height: 20px;
    box-sizing: content-box;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: auto;
      height: 20px;
    }
    &:hover,
    &:focus {
      background: $live-room-hover-bg;
    }
    &.active {
      background: $live-room-active-bg;
    }
  }
}
</style>
